import api from '@/api/index.js'

const external_emv_tap = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_EXTERNAL_EMV_TAP_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_EXTERNAL_EMV_TAP: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EXTERNAL_EMV_TAP_ERROR: (state, error) => {
      state.error = error
    },
    SET_EXTERNAL_EMV_TAP_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadExternalEmvTap({commit}, query) {
      commit('SET_EXTERNAL_EMV_TAP', null)
      commit('SET_EXTERNAL_EMV_TAP_ERROR', null)
      commit('SET_EXTERNAL_EMV_TAP_LOADING', true)
      return api.get(`emv-external-taps/${query.id}`)
        .then((response) => {
          commit('SET_EXTERNAL_EMV_TAP', response)
        })
        .catch((error) => {
          commit('SET_EXTERNAL_EMV_TAP_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EXTERNAL_EMV_TAP_LOADING', false)
        })
    }
  }
}

export default external_emv_tap
